"use client";

import React from "react";
import { WooCommerceCartBlock } from "@/integrations/wordpress/WooCommerceCartBlock";
export default function CartContent() {
  return <section id="cart-content" data-nav="dark" className="bg-background text-foreground py-12 md:py-20 min-h-[60vh] transition-colors">
      <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-12">
        <div className="rounded-xs border border-border bg-card/40 p-4 sm:p-6 lg:p-8 backdrop-blur-xs">
          <WooCommerceCartBlock />
        </div>
      </div>
    </section>;
}